import React from 'react';

import MessagesIndexQuery from 'buyside/graphql/queries/MessageIndexItems';
import PaginatedIndexQuery, { FETCH_POLICIES } from '../PaginatedIndexQueryContainer';

const MessagesIndexAreaQueryContainer = ({ mailbox, children }) => {
  const queryName = 'latestMessagePerThread';
  const currentQuery = MessagesIndexQuery;
  const variables = {};

  if (mailbox === 'unread' || mailbox === 'read' || mailbox === 'archive') {
    variables.status = mailbox;
  }

  return (
    <PaginatedIndexQuery
      query={currentQuery}
      queryName={queryName}
      pageSize={10}
      fetchPolicy={FETCH_POLICIES.NETWORK_ONLY}
      variables={variables}
    >
      {({ loading, data }) => {
        if (loading || !data) {
          return children({ loading: true });
        }

        const { indexItems, hasNextPage, fetchNextPage } = data;

        return children({
          loading: false,
          data: {
            messages: indexItems,
            hasNextPage,
            fetchNextPage
          }
        });
      }}
    </PaginatedIndexQuery>
  );
};

export default MessagesIndexAreaQueryContainer;
